// Shared "open the thing a notification points at" logic, used by the
// notification panel AND the websocket toasts so both click paths behave
// identically: the service / service-request drawer opens IN PLACE over the
// current page (GlobalServiceDrawers in AppShell), no navigation.

// Actions
import {
  openTicketDetails as openServiceDetails,
  closeModal as closeServicesModal
} from "../../redux/actions/services.actions";
import {
  openTicketDetails as openRequestDetails,
  closeModals as closeServiceRequestsModals
} from "../../redux/actions/service-requests.actions";

// Services
import { disableScroll } from "../../utils";

const TYPE_OPENERS = {
  tickets: openServiceDetails,
  service_messages: openServiceDetails,
  service_comments: openServiceDetails,
  service_requests: openRequestDetails,
  service_request_messages: openRequestDetails
};

/**
 * Opens the detail drawer for the service a notification refers to, carrying
 * the notification's branch so cross-branch opens don't 404.
 * @returns {boolean} false when the notification can't be resolved to a
 * service (unknown type / missing metadata) — caller decides the fallback.
 */
export const openNotificationService = (dispatch, notification) => {
  const open = TYPE_OPENERS[notification?.notification_type];
  const serviceId = notification?.metadata?.service?.id;
  if (!open || !serviceId) return false;

  // Close any drawer that's already open FIRST: their reducers also clear the
  // OPENED_*_DETAILS_BRANCH interceptor overrides, which would otherwise force
  // the stale branch onto the initial GET and 404 cross-branch opens.
  dispatch(closeServicesModal());
  dispatch(closeServiceRequestsModals());

  // The list pages lock body scroll on row click before opening the drawer;
  // do the same since the drawer opens over the current page.
  disableScroll();
  dispatch(open(serviceId, notification.branch_id));
  return true;
};
